import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_054.jpg';
page.images = [
  {
    imageId: 'page054_zoom0',
    rectangle: {
      x: 91 + 210,
      y: 57,
      width: 1620,
      height: 2440,
    },
    imageSrc: 'images/page054/054.jpg',
  },
];
page.paint = [
  {
    id: 'page027_game3',
    icon: 'ikona_cw4',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Narysuj obrazek związany z wakacjami.  ',
      audio: 'files/page027/z27c3.mp3',
      item: {
        path: 'informatyka/files/page027/z.27cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 600,
    },
  },
];
// page.coloring = [
//   {
//     id: 'page027_game2',
//     icon: 'ikona_cw2',
//     coloringObj: {
//       text:
//         'Nazwij miejsca wakacyjnego wypoczynku przedstawione na rysunkach. Wybierz jeden z rysunków, aby go pokolorować.',
//       audio: 'audio/z27c2.mp3',
//       items: [
//         { name: 'page027_game8', path: 'files/page054/56969_0_dzieci na plazy_original127.png' },
//         { name: 'page027_game9', path: 'files/page054/56970_0_dziecko z psem gory_original115.png' },
//       ],
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 200,
//     },
//     // rectangle: {
//     //   id: 'page016_rect2',
//     // },
//   },
// ];
page.games = [
  {
    id: 'page027_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page027_game9',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  {
    id: 'page027_game8',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page019_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 400,
  //   },
  // },
  // {
  //   id: 'page019_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 800,
  //   },
  // },
];
export default page;
